/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_PLUGINS_REQUEST]: state => {
    state.loadingPlugins = true;
    state.loadingPluginsFailed = false;
    state.loadingPluginsSucceeded = false;
  },
  [types.GET_PLUGINS_FAILURE]: (state, error) => {
    state.loadingPlugins = false;
    state.loadingPluginsFailed = true;
    state.loadingPluginsErrors = error;
  },
  [types.GET_PLUGINS_SUCCESS]: (state, data) => {
    state.loadingPlugins = false;
    state.loadingPluginsSucceeded = true;
    state.plugins = data.results;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/plugin/mutations.js